import { SectionHeader } from "@/components/SectionHeader";
import { DiamondIcon, HomeSignalIcon, StarIcon } from "@/components/icons";
import { Divider } from "@/components/Divider";

const PRINCIPLES = [
  {
    Icon: StarIcon,
    title: "Designed around the guest",
    body: "Somo complements the environment instead of competing with it. From intuitive guest controls to considered hardware, every interaction feels like it belongs.",
  },
  {
    Icon: HomeSignalIcon,
    title: "Smart behind the scenes",
    body: "The intelligence can be sophisticated without the experience feeling complicated. Somo connects systems, data, and automation so guests and teams don’t have to think about what’s happening underneath.",
  },
  {
    Icon: DiamondIcon,
    title: "More value from less",
    body: "Somo delivers a better experience without adding energy use, operational effort, or infrastructure. It reduces complexity and consumption while improving how the property performs.",
  },
];

export function WhySomoSection() {
  return (
    <section className="relative section-panel px-4 py-20 md:px-6 md:pb-32 md:pt-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 md:gap-16">
        <SectionHeader
          variant="centered"
          className="px-4 md:px-0"
          eyebrow="Why Somo"
          title="Sophisticated Technology That Never Feels Complicated"
          body="Somo is built to improve the entire equation: the guest experience, the way a property operates, and the resources it takes to run it. That means bringing intelligence and thoughtful design together in systems that simply work."
        />
        <div className="-mx-4 md:mx-0">
          <Divider />
        </div>
        <ul className="flex flex-col gap-12 md:gap-16">
          {PRINCIPLES.map((principle) => (
            <li
              key={principle.title}
              className="grid grid-cols-[auto_1fr] gap-4 px-4 md:flex md:flex-col md:items-center md:gap-6 md:px-0 md:text-center lg:grid lg:grid-cols-2 lg:items-center lg:gap-16 lg:text-left"
            >
              <div className="contents md:flex md:items-center md:gap-6">
                <principle.Icon className="row-span-2 size-10 shrink-0 text-brand md:row-auto" />
                <h3 className="text-balance text-lg leading-title text-primary md:text-2xl md:leading-tight">
                  {principle.title}
                </h3>
              </div>
              <p className="col-start-2 max-w-lg text-base leading-relaxed tracking-body text-secondary md:col-auto lg:justify-self-end">
                {principle.body}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <span
        aria-hidden
        className="absolute bottom-0 left-1/2 h-48 w-px translate-y-1/2 bg-gradient-to-b from-secondary via-line-strong to-primary"
      />
    </section>
  );
}
